import React from 'react';

import { createRoundPressControlClassName } from './roundPressControlStyles';

type Props = {
  onPress(): void;
};

export const RoundPressControlComponent: React.FC<Props> = (props) => {
  const { children, onPress } = props;

  const buttonClassName = createRoundPressControlClassName('button');

  const handleClick = React.useCallback(() => {
    onPress();
  }, [onPress]);

  return (
    <button type="button" className={buttonClassName} onClick={handleClick}>
      {children}
    </button>
  );
};
